import(/* webpackMode: "eager" */ "/vercel/path0/src/app/discover/trending/page.tsx");
